import React from 'react';

export default class Pin extends React.PureComponent {
    render() {
        let classes = ['Pin'];

        if (this.props.favorite) {
            classes.push('star');
        }
        if (this.props.spinning) {
            classes.push('spinning');
        }

        return (
            <div
                className={classes.join(' ')}
                style={{
                    top: this.props.y * this.props.height,
                    left: this.props.x * this.props.width,
                }}
                onClick={this.props.onClick}>
                <div className="mark"></div>
                {this.props.label ? <div className="label">{this.props.label}</div> : null}
            </div>
        );
    }
}
